<template>
  <div id="subscription-view" class="c-subscription c-page login">
    <div class="c-page__inner l-columns-container l-columns-container--outmost">
      <div class="l-tablet-column--4">
        <h1 class="f-headline">
          <strong>Dit</strong> abonnement
        </h1>
      </div>

      <div class="l-tablet-column--6">
        <form class="c-form general-form">
          <div
            v-if="
              this.customer &&
                this.customer.customer &&
                this.customer.customer.subscriptions.total_count &&
                this.customer.customer.subscriptions.total_count > 0
            "
            class="c-subscription__form__inner"
          >
            <div class="c-subscription__section f-text subscription-block">
              <div class="c-table__row">
                <h2 class="c-table__cell c-table__cell--label">Abonnement</h2>
                <p
                  class="c-table__cell subscription-info"
                >{{ this.getSubscription() }}</p>
              </div>

              <div
                v-if="
                  this.customer.customer.subscriptions &&
                    this.customer.customer.subscriptions.total_count > 0
                "
              >
                <label v-if="isActive()" class="c-form__submit" @click.prevent="unsubscribe()">
                  <SpinnerButton
                    ref="cancel"
                    class="c-form__submit"
                    cta="Opsig abonnement"
                    action="Opsiger"
                  />

                  <input type="submit" value="Opsig abonnement" />
                </label>

                <br />
                <label v-if="options" class="c-form__submit" @click.prevent="changeSubscription()">
                  <SpinnerButton
                    ref="change"
                    class="c-form__submit"
                    :cta="options.cta"
                    action="Ændrer abonnement"
                  />

                  <input type="submit" value="Opsig abonnement" />
                </label>
                <p v-if="options">{{ options.description }}</p>

                <label v-if="!isActive()" class="c-form__submit" @click.prevent="resubscribe()">
                  <SpinnerButton
                    ref="resubscribe"
                    class="c-form__submit"
                    cta="Genoptag abonnement"
                    action="Genoptager"
                  />

                  <input type="submit" value="Genoptag abonnement" />
                </label>
              </div>
            </div>
            <div
              v-if="!this.cancelledAtPeriodEnd && !this.free"
              class="c-table__row subscription-block"
            >
              <h2 class="c-table__cell c-table__cell--label">Næste opkrævning</h2>

              <p class="c-table__cell subscription-info">
                {{
                this.customer.customer.subscriptions.data[0]
                .current_period_end | moment("Do MMMM YYYY")
                }}
              </p>
            </div>

            <div class="c-table__row subscription-block">
              <h2 class="c-table__cell c-table__cell--label">Status</h2>
              <p class="c-table__cell subscription-info">{{ this.getStatus() }}</p>
            </div>

            <div class="c-table__row subscription-block">
              <div class="c-table__cell c-table__cell--label">
                <h2>Betalingskort</h2>
              </div>
              <p class="c-table__cell subscription-info card-info">{{ this.creditCardText }}</p>
            </div>
            <div v-if="!this.activeCard">
              <SpinnerButton
                ref="change-card"
                cta="Tilknyt betalingskort"
                action="Tilknyt betalingskort"
                @clickaction="
                  () => {
                    this.$router.push({ name: 'creditcard' });
                  }
                "
              />
            </div>
            <div v-if="this.activeCard">
              <SpinnerButton
                ref="change-card"
                cta="Skift betalingskort"
                action="Skift betalingskort"
                @clickaction="
                  () => {
                    this.$router.push({ name: 'creditcard' });
                  }
                "
              />
            </div>
          </div>
          <div
            v-if="
              this.customer &&
                this.customer.customer &&
                this.customer.customer.subscriptions &&
                this.customer.customer.subscriptions.total_count < 1
            "
          >
            <div
              v-if="!this.activeCard && !this.activeCoupon"
            >Tilknyt kreditkort eller kupon for at købe abonnement</div>

            <div v-if="this.activeCard || this.activeCoupon">
              <SpinnerButton
                ref="subscribe"
                cta="Begynd abonnement"
                action="Begynder abonnement"
                @clickaction="subscribe"
              />
              <!-- <button @click="subscribe()">Bliv medlem</button> -->
            </div>
            <div class="subscription-block">
              <h2>Betalingskort</h2>

              <p class="subscription-info card-info">{{ this.creditCardText }}</p>

              <div v-if="!this.activeCard">
                <SpinnerButton
                  ref="change-card"
                  cta="Tilknyt betalingskort"
                  action="Tilknyt betalingskort"
                  @clickaction="
                    () => {
                      this.$router.push({ name: 'creditcard' });
                    }
                  "
                />
              </div>

              <div v-if="this.activeCard">
                <SpinnerButton
                  ref="change-card"
                  cta="Skift betalingskort"
                  action="Skift betalingskort"
                  @clickaction="
                    () => {
                      this.$router.push({ name: 'creditcard' });
                    }
                  "
                />
              </div>
            </div>
          </div>
          <div v-if="this.pastPayments" class="past-payments">
            <SpinnerButton
              ref="past-payments"
              cta="Se tidligere betalinger"
              action="Se tidligere betalinger"
              @clickaction="
                () => {
                  this.$router.push({ name: 'reciepts' });
                }
              "
            />
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import SpinnerButton from "@/components/SpinnerButton.vue";

export default {
  name: "Subscription",
  components: {
    SpinnerButton,
  },
  data() {
    return {
      redirect: this.$route.query.redirect || null,
      query: this.$route.query,
      user: this.$route.meta.user,
      customer: null,
      activeCard: false,
      activeCoupon: false,
      pastPayments: false,
      creditCardText: "",
      options: {}
    };
  },
  mounted() {
    console.log(this.user);

    if (!this.user) {

      // redirect
      this.$router.push({
        name: "login",
        query: { redirect: "subscription" },
      });

      return;

    }

    this.$userService.getCustomer().then((subscription) => {
      console.log(subscription);
      // HANDLE ERROR
      this.customer = subscription;
      this.cancelledAtPeriodEnd =
        this.customer.customer.subscriptions.data[0] &&
        this.customer.customer.subscriptions.data[0].cancel_at_period_end
          ? this.customer.customer.subscriptions.data[0].cancel_at_period_end
          : false;
      this.free = false;
      if (
        subscription.customer.subscriptions &&
        subscription.customer.subscriptions.data[0] &&
        subscription.customer.subscriptions.data[0].discount &&
        subscription.customer.subscriptions.data[0].discount.coupon
      ) {
        const coupon =
          subscription.customer.subscriptions.data[0].discount.coupon;
        if (coupon.percent_off === 100 && coupon.valid) {
          this.free = true;
        }
      }
      if (
        subscription.customer &&
        subscription.customer.discount &&
        subscription.customer.discount.coupon
      ) {
        const coupon =
          subscription.customer.discount.coupon;
        if (coupon.percent_off === 100 && coupon.valid) {
          this.free = true;
        }
      }
      this.getCreditcard(subscription.customer)
        .then((data) => {
          this.creditCardText = data;
        })
        .catch((err) => {
          console.log("err");
          console.log(err);
        });
      this.$userService.getInvoices().then((response) => {
        console.log("data");
        console.log(response);

        this.reciepts = response.data.data;
        if (this.reciepts && this.reciepts.length > 0) {
          console.log("past payments");
          this.pastPayments = true;
        }
      });
      this.updateChangeOptions();

    });

  },
  methods: {
    updateChangeOptions() {
      this.$userService.getSubscriptionChangeOptions().then(response => {
        const options = response.data;

        if (!options || !options.change) {
          return;
        }

        options.cta = 'Skift til ' +  options.metadata.custom_label.toLowerCase();
        options.description = options.metadata.custom_description;
        console.log(options)
        this.options = options;

      });
    },
    changeSubscription() {

      return this.$userService.changeSubscription(this.options.plan)
        .then(data => {
          console.log(data)
          this.$refs.change.reset();
          return data;
        })
        .then(data => {
          this.$userService.getCustomer().then((subscription) => {
            console.log(subscription);
            this.customer = subscription;
          })
          this.updateChangeOptions();
          return;
        })

    },
    getSubscription() {
      if (
        this.customer.customer &&
        this.customer.customer.subscriptions &&
        this.customer.customer.subscriptions.data[0] &&
        this.customer.customer.subscriptions.data[0].plan &&
        this.customer.customer.subscriptions.data[0].plan.metadata &&
        this.customer.customer.subscriptions.data[0].plan.metadata.custom_description

      ) {

        return this.customer.customer.subscriptions.data[0].plan.metadata.custom_label;
      }
      else if (
        this.customer.customer &&
        this.customer.customer.subscriptions &&
        this.customer.customer.subscriptions.data[0] &&
        this.customer.customer.subscriptions.data[0].discount &&
        this.customer.customer.subscriptions.data[0].discount.coupon &&
        this.customer.customer.subscriptions.data[0].discount.coupon.metadata &&
        this.customer.customer.subscriptions.data[0].discount.coupon.metadata.plan
      ) {
        return this.customer.customer.subscriptions.data[0].discount.coupon.metadata.plan;
      }
      else if (
        this.customer.customer &&
        this.customer.customer.subscriptions &&
        this.customer.customer.subscriptions.data[0] &&
        this.customer.customer.subscriptions.data[0].plan &&
        this.customer.customer.subscriptions.data[0].plan.name
      ) {
        return this.customer.customer.subscriptions.data[0].plan.name
      } else {
        return '';
      }
    },
    isActive() {
      if (
        this.customer &&
        this.customer.customer &&
        this.customer.customer.subscriptions &&
        this.customer.customer.subscriptions.data[0] &&
        this.customer.customer.subscriptions.data[0].cancel_at_period_end
      ) {
        return false;
      }
      return true;
    },
    getStatus() {
      const states = {
        active: "Aktivt",
      };
      if (this.cancelledAtPeriodEnd) {
        console.log();
        return (
          "Opsagt. Du har adgang til " +
          this.$moment(
            this.customer.customer.subscriptions.data[0].current_period_end *
              1000
          ).format("Do MMMM YYYY")
        );
      }
      return states[this.customer.customer.subscriptions.data[0].status];
    },
    getCreditcard(customer) {
      return new Promise((resolve, reject) => {
        if (!customer) {
          return false;
        }
        let card = null;
        this.$userService
          .getPaymentMethod(customer)
          .then((card) => {
            card = card;
            console.log(card);
            if (card) {
              const date = new Date();
              console.log(date.getFullYear(), card.exp_year)

              if (
                card.exp_year < date.getFullYear() ||
                (card.exp_year == date.getFullYear() &&
                  card.exp_month <= date.getMonth() + 1)
              ) {
                resolve("Det tilknyttede kort er udløbet.");
              }

              this.setCardState(true);
              resolve(card.brand + " **** **** **** " + card.last4);
            } else {
              resolve("Intet kort tilknyttet.");
            }
          })
          .catch((err) => {
            reject("Intet kort tilknyttet.");
          });
      });
    },
    setCardState(state) {
      this.activeCard = state;
    },
    unsubscribe() {
      const sid = this.customer.customer.subscriptions.data[0].id;
      this.$userService
        .unsubscribe(sid)
        .then((data) => {
          console.log("subsc");
          this.$userService.getCustomer().then((subscription) => {
            console.log(subscription);
            // HANDLE ERROR
            this.customer = subscription;
            this.$refs.cancel.reset();
          });
        })
        .catch((err) => {
          console.log("error");
          console.log(err);
        });
    },
    subscribe() {
      this.$userService
        .subscribe(null, process.env.VUE_APP_DEFAULT_PLAN)
        .then((data) => {
          console.log("subsc");
          console.log(data);
          this.$userService.getCustomer().then((subscription) => {
            console.log(subscription);
            this.updateChangeOptions();
            // HANDLE ERROR
            this.customer = subscription;
            this.cancelledAtPeriodEnd = this.customer.customer.subscriptions.data[0].cancel_at_period_end;
            this.$refs.subscribe.reset();
            if (this.redirect) {
              return this.$router.push({
                name: this.redirect,
                query: this.query,
              });
            }
          });
        })
        .catch((err) => {
          console.log("error");
          console.log(err);
        });
    },
    resubscribe() {
      const sid = this.customer.customer.subscriptions.data[0].id;
      this.$userService
        .resubscribe(sid)
        .then((data) => {
          console.log("subsc");
          console.log(data);
          this.$userService.getCustomer().then((subscription) => {
            console.log(subscription);
            // HANDLE ERROR
            this.customer = subscription;
            this.cancelledAtPeriodEnd = this.customer.customer.subscriptions.data[0].cancel_at_period_end;
            this.$refs.resubscribe.reset();
          });
        })
        .catch((err) => {
          console.log("error");
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.c-subscription {
  &__form__inner {
    width: 100%;
  }

  &__section {
    margin-bottom: 3em;
  }
}
.card-info {
  text-transform: capitalize;
}
.past-payments {
  margin-top: 1em;
}
</style>
